import PokerCard from "../components/PokerCard.svelte";

var greatestPokerCard = [];
var count = 0;

function isFlush(c)
{
    if (c.length < 5)
        return false;

    if (c[0].getColor() == c[1].getColor() &&
        c[0].getColor() == c[2].getColor() &&
        c[0].getColor() == c[3].getColor() &&
        c[0].getColor() == c[4].getColor()) 
    {
        greatestPokerCard[count] = c[4];
        return true;
    }
    return false;
}

function isStraight(c)
{
    if (c.length < 5)
        return false;

    if (c[0].getRank() == c[1].getRank()-1 &&
        c[1].getRank() == c[2].getRank()-1 &&
        c[2].getRank() == c[3].getRank()-1 &&
        c[3].getRank() == c[4].getRank()-1)
    {
        greatestPokerCard[count] = c[4];
        return true;
    }

    if (c[0].getRank() == 2 &&
        c[1].getRank() == 3 &&
        c[2].getRank() == 4 &&
        c[3].getRank() == 5 &&
        c[4].getRank() == 14)
    {
        greatestPokerCard[count] = c[3];
        return true;
    }
    return false;
}

function isRoyalFlush(c)
{
    if (c.length < 5)
        return false;

    if (isStraightFlush(c) && c[4].getRank() == 14)
    {
        greatestPokerCard[count] = c[4];
        return true;
    }
    return false;
}

function isStraightFlush(c)
{
    if (c.length < 5)
        return false;
    
    if (isFlush(c) && isStraight(c))
    {
        greatestPokerCard[count] = c[4];
        return true;
    }
    return false;
}

function isFourOfAKind(c)
{
    if (c.length < 5)
        return false;
    
    if (c[0].getRank() == c[3].getRank() || c[1].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[3];
        return true;
    }
    return false;
}

function isFullHouse(c)
{
    if (c.length < 5)
        return false;
    
    if (c[0].getRank() == c[2].getRank() && c[3].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[2];
        return true;
    }
    if (c[0].getRank() == c[1].getRank() && c[2].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[2];
        return true;
    }
    return false;
}

function isThreeOfAKind(c)
{
    if (c.length < 5)
        return false;
    
    if (c[0].getRank() == c[2].getRank() || c[1].getRank() == c[3].getRank() || c[2].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[2];
        return true;
    }
    return false;
}

function isTwoPairs(c)
{
    if (c.length < 5)
        return false;
    
    if (c[0].getRank() == c[1].getRank() && c[2].getRank() == c[3].getRank())
    {
        greatestPokerCard[count] = c[3];
        greatestPokerCard[count+2] = c[1];
        return true;
    }
    if (c[1].getRank() == c[2].getRank() && c[3].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[4];
        greatestPokerCard[count+2] = c[2];
        return true;
    }
    if (c[0].getRank() == c[1].getRank() && c[3].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[4];
        greatestPokerCard[count+2] = c[1];
        return true;
    }
    return false;
}

function isPair(c)
{
    if (c[0] && c[1] && c[0].getRank() == c[1].getRank())
    {
        greatestPokerCard[count] = c[1];
        return true;
    }
    if (c[1] && c[2] && c[1].getRank() == c[2].getRank())
    {
        greatestPokerCard[count] = c[2];
        return true;
    }
    if (c[2] && c[3] && c[2].getRank() == c[3].getRank())
    {
        greatestPokerCard[count] = c[3];
        return true;
    }
    if (c[3] && c[4] && c[3].getRank() == c[4].getRank())
    {
        greatestPokerCard[count] = c[4];
        return true;
    }
    return false;
}

//-------------------------------------------------------------------------------------------

export function score(c)
{
    if (isRoyalFlush(c))
        return 9;
    else if (isStraightFlush(c))
        return 8;
    else if (isFourOfAKind(c))
        return 7;
    else if (isFullHouse(c))
        return 6;
    else if (isFlush(c))
        return 5;
    else if (isStraight(c))
        return 4;
    else if (isThreeOfAKind(c))
        return 3;
    else if (isTwoPairs(c))
        return 2;
    else if (isPair(c))
        return 1;
    else
        return 0;
}

export function scoreToString(score)
{
    switch (score)
    {
        case 9: return "Royal Flush";
        case 8: return "Straight Flush";
        case 7: return "Four of a Kind";
        case 6: return "Full House";
        case 5: return "Flush";
        case 4: return "Straight";
        case 3: return "Three of a Kind";
        case 2: return "Two Pairs";
        case 1: return "One Pair";
        case 0: return "High PokerCard";
        default: return null;
    }
}

//-------------------------------------------------------------------------------------------

function compareHands(c1, c2)
{
    let cardsStr = "";
    for(let c of c1)
        cardsStr += c.getRank() + c.getColor() + ", ";
    console.log(cardsStr)

    greatestPokerCard[0] = null;
    greatestPokerCard[1] = null;

    count = 0;
    let score1 = score(c1);
    count = 1;
    let score2 = score(c2);

    if (score1 < score2)
        return -1;
    else if (score1 > score2)
        return 1;
    else
    {
        if (greatestPokerCard[0] && greatestPokerCard[1] && greatestPokerCard[0].compareTo( greatestPokerCard[1] ) != 0)
        {
            return greatestPokerCard[0].compareTo(greatestPokerCard[1]);
        }
        else if ( score1 == 2 )
        {
            if (greatestPokerCard[2] && greatestPokerCard[3] && greatestPokerCard[2].compareTo( greatestPokerCard[3] ) != 0)
                return greatestPokerCard[2].compareTo(greatestPokerCard[3]);
        }

        for (let i = 4; i >= 0; i--)
            if (c1[i].getRank() != c2[i].getRank())
                return (c1[i].getRank() - c2[i].getRank());

        return 0;
    }
}

export function getBestTexasHand(c , n)
{
    let comb = [];

    if (n == 2)
        return c;	//just the hole cards

    if (n == 5)
    {
        comb = [31];
    }

    if (n == 6)
    {
        comb = [62, 61, 59, 55, 47, 31];
    }

    if (n == 7)
    {
        comb = [124, 122, 121, 118, 117, 115, 110, 109, 107,
            103, 94, 93, 91, 87, 79, 62, 61, 59, 55, 47, 31];
    }

    let bestHand = [];
    let tempHand = [];

    c.sort((a, b) => { 
        if (a.getRank() < b.getRank())
            return -1;
        else if (a.getRank() == b.getRank())
            return 0;
        else
            return 1;
     });

    for(let i = 0; i < 5; i++ )
        bestHand[i] = c[i];

    for (let i of comb)
    {
        let pos = 0;
        for (let j = 0; j < n; j++)
            if (( i & (1 << j) ) != 0)
            {
                tempHand[pos] = c[j];
                pos++;
            }

        if (compareHands(tempHand, bestHand) >= 0)
            for ( let k = 0; k < 5; k++ )
                bestHand[k] = tempHand[k];

    }

    return bestHand;
}